// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__IZABS","loading__container":"button_loading__container__GlmKg","btn__icon__container":"button_btn__icon__container__NiC_m"};